/* Ay-Line size finder (ANIME STYLE): sliders, animated fighter, same sizing rules as assets/ayline-size-finder.js. */
(function () {
  'use strict';
  var panel = document.querySelector('[data-as-finder]');
  if (!panel) return;
  var bg = document.querySelector('[data-as-finder-bg]');
  var S = window.asFinderStrings || {};
  var ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  var STORAGE_KEY = 'ayl-fit-profile';
  /* Approved by Ay-Line for the standard tee. */
  var MAX_HEIGHT_CM = { S: 169, M: 177, L: 184, XL: 191, '2XL': 197, '3XL': 999 };
  var MAX_WEIGHT_KG = { S: 62, M: 72, L: 82, XL: 93, '2XL': 105, '3XL': 999 };
  /* Smallest comfortable flat measurement per size; we only ever size up. */
  var CATEGORIES = {
    tee: { row: 'chest', minimum: { S: 49, M: 53, L: 57, XL: 61, '2XL': 65, '3XL': 69 } },
    hoodie: { row: 'chest', minimum: { S: 52, M: 56, L: 60, XL: 64, '2XL': 68, '3XL': 72 } },
    denim: { row: 'waist', minimum: { S: 38.25, M: 40.75, L: 44, XL: 48, '2XL': 52, '3XL': 56 } },
    compression: null,
    elastic: null
  };
  /* Fighter proportions */
  var HEIGHT_RANGE = [150, 205], HEIGHT_SCALE = [0.86, 1.1];
  var BMI_RANGE = [17, 36], BUILD_SCALE = [0.82, 1.42];
  var BMI_STEPS = [20, 25, 29, Infinity];
  var POWER_STEP = 3; /* last build = golden transformation */
  var NECK_Y = 108, GROUND_Y = 310;

  var q = function (sel) { return panel.querySelector(sel); };
  var g = function (name) { return panel.querySelector('[data-as-g="' + name + '"]'); };
  var hIn = q('[data-as-h]'), wIn = q('[data-as-w]');
  var state = { fit: 'regular' };

  function categoryFor(title) {
    var t = title.toLowerCase();
    if (/jeans|denim|shorts/.test(t)) return 'denim';
    if (/sweatpants|joggers|pants|trousers/.test(t)) return 'elastic';
    if (/compression/.test(t)) return 'compression';
    if (/hoodie|sweatshirt|crewneck|jacket|zip|sweater|cardigan/.test(t)) return 'hoodie';
    return 'tee';
  }

  /* Reads the size chart from the product description table: first row sizes, second row units. */
  function readChart(rowName) {
    var tables = document.querySelectorAll('.as-rte table');
    for (var t = 0; t < tables.length; t++) {
      var grid = [];
      tables[t].querySelectorAll('tr').forEach(function (tr) {
        var line = [];
        tr.querySelectorAll('td,th').forEach(function (cell) {
          var span = parseInt(cell.getAttribute('colspan'), 10) || 1;
          for (var s = 0; s < span; s++) line.push(cell.textContent.replace(/ /g, ' ').trim());
        });
        grid.push(line);
      });
      if (grid.length < 3) continue;
      for (var r = 2; r < grid.length; r++) {
        if ((grid[r][0] || '').toLowerCase().indexOf(rowName) !== 0) continue;
        var values = {};
        for (var c = 1; c < grid[r].length; c++) {
          var size = (grid[0][c] || '').toUpperCase(), unit = (grid[1][c] || '').toLowerCase();
          var n = parseFloat((grid[r][c] || '').replace(',', '.'));
          if (unit === 'cm' && size && !isNaN(n)) values[size] = n;
        }
        var sample = values.M || values.S || values.L;
        if (!sample) return null;
        var limit = rowName === 'waist' ? 55 : 90;
        if (sample > limit) Object.keys(values).forEach(function (k) { values[k] = values[k] / 2; });
        return values;
      }
    }
    return null;
  }

  var ctx = {
    available: panel.dataset.sizes.split(',').map(function (s) { return s.trim().toUpperCase(); })
      .filter(function (s) { return ORDER.indexOf(s) !== -1; })
      .sort(function (a, b) { return ORDER.indexOf(a) - ORDER.indexOf(b); }),
    category: categoryFor(panel.dataset.title || '')
  };
  var rule = CATEGORIES[ctx.category];
  ctx.chart = rule ? readChart(rule.row) : null;

  function standardSize(cm, kg) {
    var sizes = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
    for (var i = 0; i < sizes.length; i++) {
      if (cm <= MAX_HEIGHT_CM[sizes[i]] && kg <= MAX_WEIGHT_KG[sizes[i]]) return sizes[i];
    }
    return '3XL';
  }

  function recommend(base) {
    var target = ORDER[Math.min(ORDER.indexOf(base) + (state.fit === 'oversized' ? 1 : 0), ORDER.length - 1)];
    var pick = target, chart = ctx.chart;
    var reliable = rule && chart && rule.minimum[target] && (chart.M || chart.S || 0) >= rule.minimum.S - 6;
    if (reliable) {
      var fromTarget = ctx.available.filter(function (s) { return ORDER.indexOf(s) >= ORDER.indexOf(target); });
      var match = fromTarget.filter(function (s) { return chart[s] && chart[s] >= rule.minimum[target]; })[0];
      pick = match || fromTarget[fromTarget.length - 1] || target;
    }
    var largest = ctx.available[ctx.available.length - 1], capped = false;
    if (ctx.available.indexOf(pick) === -1 && largest && ORDER.indexOf(pick) > ORDER.indexOf(largest)) { pick = largest; capped = true; }
    return { size: pick, shift: ORDER.indexOf(pick) - ORDER.indexOf(target), capped: capped };
  }

  function lerp(range, out, v) {
    var t = Math.min(1, Math.max(0, (v - range[0]) / (range[1] - range[0])));
    return out[0] + (out[1] - out[0]) * t;
  }

  function draw(cm, kg) {
    var bmi = kg / Math.pow(cm / 100, 2);
    var h = lerp(HEIGHT_RANGE, HEIGHT_SCALE, cm), w = lerp(BMI_RANGE, BUILD_SCALE, bmi);
    g('fitBody').style.transform = 'scale(' + w.toFixed(3) + ',' + h.toFixed(3) + ')';
    g('fitHead').style.transform = 'translateY(' + ((GROUND_Y - NECK_Y) * (1 - h)).toFixed(1) + 'px)';
    panel.querySelector('.as-g-fit__shadow').style.transform = 'scaleX(' + w.toFixed(3) + ')';
    g('muscle').style.opacity = Math.min(1, Math.max(0, (w - 1.02) / 0.25)).toFixed(2);
    var step = BMI_STEPS.findIndex(function (limit) { return bmi < limit; });
    var powered = step === POWER_STEP;
    var label = (S.builds && S.builds[step]) || '';
    q('[data-as-build]').textContent = powered ? label + ' ⚡' : label;
    g('fitGuy').classList.toggle('is-ssj', powered);
    q('[data-as-stage-fig]').classList.toggle('is-ssj', powered);
  }

  function paint(input) {
    input.style.setProperty('--p', ((input.value - input.min) / (input.max - input.min) * 100) + '%');
  }

  function render() {
    var cm = Number(hIn.value), kg = Number(wIn.value);
    var inches = Math.round(cm / 2.54);
    q('[data-as-h-out]').textContent = cm + ' cm · ' + Math.floor(inches / 12) + '′' + (inches % 12) + '″';
    q('[data-as-w-out]').textContent = kg + ' kg · ' + Math.round(kg * 2.2046) + ' lb';
    paint(hIn); paint(wIn);
    draw(cm, kg);
    var rec = recommend(standardSize(cm, kg));
    q('[data-as-size]').textContent = rec.size;
    var pick = q('[data-as-pick]');
    pick.dataset.size = rec.size;
    pick.textContent = (S.select || 'Select {{ size }}').replace('{{ size }}', rec.size);
    var msg = '';
    if (rec.capped) msg = (S.capped || '').replace('{{ size }}', rec.size);
    else if (rec.shift > 0) msg = (S.up || '').replace('{{ count }}', rec.shift);
    q('[data-as-note]').textContent = msg;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ unit: 'metric', fit: state.fit, heightCm: cm, weightKg: kg })); } catch (e) {}
  }

  function toggle(on) {
    panel.classList.toggle('is-on', on);
    bg.classList.toggle('is-on', on);
    panel.setAttribute('aria-hidden', String(!on));
    if (on) { panel.removeAttribute('inert'); q('[data-as-finder-close]').focus(); } else { panel.setAttribute('inert', ''); }
  }

  document.addEventListener('click', function (e) { if (e.target.closest('[data-as-finder-open]')) toggle(true); });
  q('[data-as-finder-close]').addEventListener('click', function () { toggle(false); });
  bg.addEventListener('click', function () { toggle(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });
  panel.querySelectorAll('button[data-fit]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.fit = b.dataset.fit;
      panel.querySelectorAll('button[data-fit]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      render();
    });
  });
  hIn.addEventListener('input', render);
  wIn.addEventListener('input', render);
  q('[data-as-pick]').addEventListener('click', function () {
    var size = this.dataset.size;
    var btn = Array.prototype.find.call(document.querySelectorAll('.as-option__values--size button'), function (b) {
      return b.dataset.value.trim().toUpperCase() === size;
    });
    if (btn) btn.click();
    toggle(false);
  });

  try {
    var saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (saved && saved.heightCm && saved.weightKg) {
      hIn.value = saved.heightCm; wIn.value = saved.weightKg;
      if (saved.fit === 'oversized') state.fit = 'oversized';
      panel.querySelectorAll('button[data-fit]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.fit === state.fit)); });
    }
  } catch (e) {}
  render();
})();
